<template>
  <div>
    <Chart :cdata="cdata" :height="style.height" :width="style.width"/>
  </div>
</template>

<script>
import BigTitle from '../../bigTitle';
import Chart from '../chart.vue'
import Title from '../../title.vue'
import { batteryBoxRight } from '@/api/batteryBox/right';
import { dataInterface } from '@/api/dataInterfaceApi';
import {formatTime} from '@/utils/index'

export default {
  data () {
    return {
      style:{
        width: '550',
        height: '250'
      },
      cdata: {
        category: [],
        rateData: [],
        id:"carAddChart",
        legendData:[{
              name:"电量",
              icon: 'roundRect',
        }],
        series:[
            {
              name: "电量",
              type: "line",
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: '#7C6AF2 '
                }
              },
              data: []
            }
        ],
        yAxisname:""
      }
    };
  },
  components: {
    BigTitle,
    Chart,
    Title
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.getStationNum(data)
    },
    getStationNum(data={}){
      let _this = this;
      dataInterface
        .dataFaceApi({
          "enCode":"genjustationidfanhuinum",
          "@station_id":_this.$route.query.stationId,
      })
        .then((res) => {
          if (!res) return;
          _this.selectinformationdata(data,res[0].station_num)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectinformationdata(data={},num){
      let date = new Date();
      let year = date.getFullYear();
      let mouth = date.getMonth()+1;
      mouth = mouth.length>1?mouth:"0"+mouth;
      let  params = {
          "enCode":"TD-dianliangqushitu",
          "@station_num":num,
          "@cur_date":year+"-"+mouth+"-01 00:00:00"
      }
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          console.log("电量数据",res)
          let maxElectMeter=[];
          let xList=[];
          res.map(item=>{
            maxElectMeter.push(item.maxelectmeter);
            xList.push(formatTime(item.ts,'yyyy-MM-dd'),);
          })
          this.cdata.category = xList;//
          this.cdata.series[0].data = maxElectMeter;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
};
</script>

<style lang="scss" scoped>
</style>